"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaNetworkOptionsResponseToJSON = exports.RosettaNetworkOptionsResponseFromJSONTyped = exports.RosettaNetworkOptionsResponseFromJSON = void 0;
const _1 = require("./");
function RosettaNetworkOptionsResponseFromJSON(json) {
    return RosettaNetworkOptionsResponseFromJSONTyped(json, false);
}
exports.RosettaNetworkOptionsResponseFromJSON = RosettaNetworkOptionsResponseFromJSON;
function RosettaNetworkOptionsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'version': _1.RosettaNetworkOptionsResponseVersionFromJSON(json['version']),
        'allow': _1.RosettaNetworkOptionsResponseAllowFromJSON(json['allow']),
    };
}
exports.RosettaNetworkOptionsResponseFromJSONTyped = RosettaNetworkOptionsResponseFromJSONTyped;
function RosettaNetworkOptionsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'version': _1.RosettaNetworkOptionsResponseVersionToJSON(value.version),
        'allow': _1.RosettaNetworkOptionsResponseAllowToJSON(value.allow),
    };
}
exports.RosettaNetworkOptionsResponseToJSON = RosettaNetworkOptionsResponseToJSON;
//# sourceMappingURL=RosettaNetworkOptionsResponse.js.map